import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { GET_LIST } from "react-admin";
import blueGrey from "@material-ui/core/colors/blueGrey";
import trucknetRestClient from "../trucknetRestClient";
import { withRouter } from "react-router-dom";

const blueGrey500 = blueGrey["500"];

class Badge extends React.Component {
  _isMounted = false;

  state = {
    value: null,
  };

  static defaultProps = {
    getValue: (res) => (res ? res.total : 0),
    filterQuery: {},
    color: blueGrey500,
    href: null,
  };

  componentDidMount() {
    this._isMounted = true;
    this.fetchBadgeValue();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchBadgeValue = async () => {
    const res = await trucknetRestClient(GET_LIST, this.props.resource, {
      filter: this.props.filterQuery,
      pagination: { page: 1 },
    });

    if (this._isMounted) {
      this.setState({ value: this.props.getValue(res) });
    }
  };

  render() {
    const { title, icon, color, hasLink, resource, filterQuery } = this.props;

    const styles = {
      card: {
        borderLeft: `solid 4px ${color}`,
        marginBottom: 16,
        display: "flex",
        alignItems: "center",
        cursor: hasLink ? "pointer" : "initial",
      },
    };

    const cardContent = (
      <Card style={styles.card}>
        {React.cloneElement(icon)}
        <CardHeader title={this.state.value} subheader={title} />
      </Card>
    );

    if (hasLink) {
      let to = resource;
      if (Object.keys(filterQuery).length !== 0) {
        to = encodeURI(`${to}?filter=${JSON.stringify(filterQuery)}`);
      }
      return (
        <a
          onClick={() => {
            this.props.history.push(to);
            return false;
          }}>
          {cardContent}
        </a>
      );
    } else {
      return cardContent;
    }
  }
}

export default withRouter(Badge);



// WEBPACK FOOTER //
// ./src/dashboard/Badge.js